import { render, staticRenderFns } from "./SimpleFnolDialog.vue?vue&type=template&id=5989a8d0&"
import script from "./SimpleFnolDialog.vue?vue&type=script&lang=js&"
export * from "./SimpleFnolDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports